require('../modules/esnext.string.code-points');